import { memo } from 'react';

import { UserFilter as GenericUserFilter } from '../../../../components/PageFilters/filters/UserFilter';
import type { UserFilterProps } from './types';

export const auditTrailUserFilterKey = 'audit-trail-user-filter';

export const UserFilter = memo((props: UserFilterProps) => {
  return <GenericUserFilter {...props} label="Filter by user" readableValuePrefix="User" />;
});
